import React, { useState } from "react";
import "./Login.css";
import { FaFlagCheckered } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { loginAdmin } from "../Pages/AdminProfile/adminSlice/adminSlice";
import { useNavigate } from "react-router-dom";

const IconKart = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M4 17L8 6h2.5L7 14h5.5L10 17H4z" fill="white" opacity="0.9" />
        <path d="M11 17l4-11h2.5l-4 11H11z" fill="white" />
        <circle cx="17" cy="6" r="1.8" fill="white" opacity="0.7" />
    </svg>
);

const IconEmail = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="1.5" y="3" width="13" height="10" rx="2" stroke="currentColor" strokeWidth="1.3" />
        <path d="M1.5 5.5L8 9.5l6.5-4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
);

const IconLock = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
        <path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <circle cx="8" cy="10.5" r="1" fill="currentColor" />
    </svg>
);

const IconEyeOpen = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke="currentColor" strokeWidth="1.3" />
        <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.3" />
    </svg>
);

const IconEyeClosed = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M2 2l12 12M6.5 6.6A2 2 0 0010 10.1M5 4.3C2.9 5.7 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M9.5 4.1C11.9 5 14 7.3 14 8"
            stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
        />
        <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.3" />
    </svg>
);

const IconArrow = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M6 3H3a1 1 0 00-1 1v8a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6"
            stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
        />
    </svg>
);

const IconCheck = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3 8l3.5 3.5L13 4" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const IconAlert = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="7" cy="7" r="6.5" stroke="#ff6060" strokeWidth="1.2" />
        <path d="M7 4v4M7 9.5v.5" stroke="#ff6060" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

function Login() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [remember, setRemember] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        if (error) setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.email || !form.password) {
            setError("Please fill in all fields.");
            return;
        }

        const result = await dispatch(loginAdmin(form));

        if (result.meta.requestStatus === "fulfilled") {
            setSuccess(true);

            setTimeout(() => {
                navigate("/dashboard");
            }, 1000);
        } else {
            setError(result.payload);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card animate-in">

                {/* Brand */}
                <div className="login-brand">
                    <div className="login-brand-icon">
                        <FaFlagCheckered size={20} />
                    </div>
                    <h1 className="login-brand-name">VEGAS KARTS</h1>
                </div>

                {/* Divider */}
                <div className="login-divider">
                    <span className="login-divider-line" />
                    <p className="login-divider-text">Sign in to continue</p>
                    <span className="login-divider-line" />
                </div>

                {/* Error */}
                {error && (
                    <div className="login-error show">
                        <IconAlert />
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} noValidate>

                    {/* Email */}
                    <div className="login-input-group">
                        <label className="login-input-label" htmlFor="email">Email Address</label>
                        <div className="login-input-wrap">
                            <span className="login-input-icon"><IconEmail /></span>
                            <input
                                id="email"
                                type="email"
                                name="email"
                                className="login-input"
                                placeholder="Enter Email Adress"
                                value={form.email}
                                onChange={handleChange}
                                autoComplete="email"
                            />
                        </div>
                    </div>

                    {/* Password */}
                    <div className="login-input-group">
                        <label className="login-input-label" htmlFor="password">Password</label>
                        <div className="login-input-wrap">
                            <span className="login-input-icon"><IconLock /></span>
                            <input
                                id="password"
                                type={showPassword ? "text" : "password"}
                                name="password"
                                className="login-input has-right"
                                placeholder="Enter your password"
                                value={form.password}
                                onChange={handleChange}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="login-eye-btn"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label="Toggle password visibility"
                            >
                                {showPassword ? <IconEyeClosed /> : <IconEyeOpen />}
                            </button>
                        </div>
                    </div>

                    {/* Remember + Forgot */}
                    <div className="login-row">
                        <label className="login-remember">
                            <input
                                type="checkbox"
                                className="login-checkbox"
                                checked={remember}
                                onChange={(e) => setRemember(e.target.checked)}
                            />
                            <span className="login-remember-label">Remember me</span>
                        </label>
                        <button type="button" className="login-forgot">
                            Forgot password?
                        </button>
                    </div>

                    {/* Submit */}
                    <button
                        type="submit"
                        className={`login-btn${success ? " success" : ""}`}
                    >
                        {success ? (
                            <><IconCheck /> Welcome Back!</>
                        ) : (
                            <><IconArrow /> Login</>
                        )}
                    </button>
                </form>

                {/* Footer */}
                <div className="login-footer-row">
                    <span className="login-footer-text">Need access?</span>
                    <button type="button" className="login-contact-btn">Contact Admin</button>
                </div>

            </div>
        </div>
    );
}

export default Login;